<template>
  <div>
    <div class="card-container" v-if="data">
      <div class="scroller">
        <loading-component :value="loading" />
        <order-card :id="parseInt($route.params.id)" :data="data" />
        <additional-info v-if="data.geofence_logs.length > 0" :title="$t('dispatching.ridePage.enteringPickupRadius')">
          <table class="additional-info-logs">
            <tr v-if="data.geofence_logs[0].enter_time">
              <td>{{ $t("dispatching.ridePage.entered") }}</td>
              <th>
                {{
                  moment(data.geofence_logs[0].enter_time).format(
                    "HH[h]mm[m]ss[s] DD/MM/YYYY"
                  )
                }}
              </th>
            </tr>
            <tr v-if="data.geofence_logs[0].leave_time">
              <td>{{ $t("dispatching.ridePage.leaved") }}</td>
              <th>
                {{
                  moment(data.geofence_logs[0].leave_time).format(
                    "HH[h]mm[m]ss[s] DD/MM/YYYY"
                  )
                }}
              </th>
            </tr>
          </table>
        </additional-info>
        <additional-info v-if="data.summary && data.summary.passenger_rating" :title="$t('dispatching.ridePage.rating')">
          <table class="additional-info-logs">
            <tr v-if="data.summary.passenger_rating">
              <td>{{ $t("dispatching.ridePage.passengerRating") }}</td>
              <th>
                <v-rating style="display: inline" :value="data.summary.passenger_rating"
                  background-color="yellow accent-4" color="yellow accent-4" readonly dense half-increments hover
                  small></v-rating>
                <span class="grey--text text--lighten-2 caption mr-2">
                  ({{ data.summary.passenger_rating }})
                </span>
              </th>
            </tr>
            <tr v-if="data.summary.passenger_rating_cause">
              <td>{{ $t("dispatching.ridePage.passengerComment") }}</td>
              <th>
                {{
                  data.summary.passenger_rating_cause
                }}
              </th>
            </tr>
          </table>
        </additional-info>
        <logs-table :logs="filteredStatusesLogs" :color-coding="actionsColorCoding" title-key="status"
          color-coding-key="value" datetime-key="created_at" v-if="filteredStatusesLogs.length" />
        <div class="complaints-container">
          <v-select :label="$t('common.select')" v-model="complaintSelectedVal" item-text="name" item-value="id"
            :items="complaintCategories" :placeholder="$t('dispatching.ridePage.selectCategory')"></v-select>
          <button class="complaint-button" @click="saveCategory()">{{ $t("common.save") }}</button>
        </div>
        <logs-table :logs="data.all_complaints" title-key="description" datetime-key="created_at" doer-key="doer"
          captain-key="entity_id" :complaintStatus="complaintStatus" :addButton="true" @added="addComplaint"
          @showDetails="showDetails" @changeComplaintStatus="changeComplaintStatus" />
        <v-dialog v-model="treatConfirmDialog" max-width="600" @click:outside="cancelTreatedStatus">
          <div class="treat-confirm-modal">
            <div class="tc-close-button noselect" @click="cancelTreatedStatus"><span>&#128473;</span></div>
            <h2 class="tc-title">{{ $t("dispatching.ridePage.confirmStatusChange") }}</h2>
            <p class="tc-text">{{ $t("dispatching.ridePage.treatedWarning") }}</p>
            <div class="tc-buttons">
              <button class="tc-btn" outline @click="cancelTreatedStatus">{{ $t("common.cancel") }}</button>
              <button class="tc-btn" @click="confirmTreatedStatus">{{ $t("common.continue") }}</button>
            </div>
          </div>
        </v-dialog>
      </div>
    </div>
    <GmapMap :center="center" :options="options" :zoom="zoom" ref="map" class="map" v-if="data">
      <GmapCluster>
        <GmapPolyline :options="{ strokeColor: '#000' }" :path="path"></GmapPolyline>
        <GmapMarker :icon="{
          url: require('@/assets/map/pickup-pin.svg'),
          scaledSize: { width: 34, height: 42 },
        }" :position="{
          lat: data.pick_up_location.coordinates[1],
          lng: data.pick_up_location.coordinates[0],
        }" @mouseover="showByIndex = 'pickup'" @mouseout="showByIndex = null">
          <gmap-info-window :opened="showByIndex == 'pickup'">
            <p style="margin-bottom: 0">{{ $t("dispatching.ridePage.pickupLocation") }}</p>
          </gmap-info-window>
        </GmapMarker>
        <GmapMarker :icon="{
          url: require('@/assets/map/dropoff-pin.svg'),
          scaledSize: { width: 34, height: 42 },
        }" :position="{
          lat: data.pull_down_location.coordinates[1],
          lng: data.pull_down_location.coordinates[0],
        }" @mouseover="showByIndex = 'dropoff'" @mouseout="showByIndex = null">
          <gmap-info-window :opened="showByIndex == 'dropoff'">
            <p style="margin-bottom: 0">{{ $t("dispatching.ridePage.dropoffLocation") }}</p>
          </gmap-info-window>
        </GmapMarker>
        <GmapMarker v-for="(marker, index) in data.statuses" v-if="
          !['APPROVED', 'ACCEPTED', 'ARRIVED', 'PAID', 'STARTED'].includes(
            marker.status
          )
        " :key="index" :icon="{
          url: formSvg(actionsColorCoding[marker.value]),
          scaledSize: { width: 50, height: 35 },
        }" :position="{
          lat: marker.location.coordinates[1],
          lng: marker.location.coordinates[0],
        }" @mouseover="showByIndex = index" @mouseout="showByIndex = null">
          >
          <gmap-info-window :opened="showByIndex === index">
            <p style="margin-bottom: 0">
              {{ $t("dispatching.ridePage.statusAt", { status: marker.status, time: moment(marker.created_at).format("HH[h]mm") }) }}
            </p>
          </gmap-info-window>
        </GmapMarker>
        <GmapMarker :icon="{
          url: require('@/assets/markers/FREE.png'),
          scaledSize: { width: 34, height: 42 },
        }" v-if="startTracking" :position="{
          lat: driverLocation.lat,
          lng: driverLocation.lng,
        }" />
      </GmapCluster>
    </GmapMap>

  </div>

</template>
<script>
/* eslint-disable */

import OrderCard from "@/components/dispatching/OrderCard.vue";
import LogsTable from "@/components/dispatching/LogsTable.vue";
import AdditionalInfo from "@/components/dispatching/AdditionalInfo.vue";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import GmapPolyline from "vue2-google-maps/dist/components/polyline";
import socketEventsMixin from "@/mixins/socketEventsMixin";
import axios from "axios";
import api from "@/constants/api";
import LoadingComponent from "@/components/LoadingComponent";
import i18n from "@/i18n";

const options = {
  mapTypeId: "roadmap",
  disableDefaultUI: true,
  styles: [
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#a3a4ae",
        },
      ],
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [
        {
          color: "#e6eaf0",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [
        {
          visibility: "simplified",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "labels.text",
      stylers: [
        {
          visibility: "simplified",
        },
        {
          gamma: "2",
        },
        {
          lightness: "3",
        },
        {
          color: "#778494",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "labels.icon",
      stylers: [
        {
          color: "#788E98",
        },
      ],
    },
    {
      featureType: "poi.attraction",
      elementType: "geometry.fill",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [
        {
          visibility: "on",
        },
        {
          color: "#ceead6",
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#39b65c",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: [
        {
          saturation: "0",
        },
        {
          lightness: "35",
        },
        {
          visibility: "simplified",
        },
        {
          gamma: "1",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [
        {
          visibility: "simplified",
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#fde293",
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
        {
          saturation: "-50",
        },
        {
          lightness: "17",
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [
        {
          color: "#8fbaff",
        },
        {
          visibility: "on",
        },
      ],
    },
  ],
};

// {
//   position: {
//     lat: 43.738359,
//     lng: 7.426723,
//   },
//   icon: {
//     url: require("@/assets/map/pickup-pin.svg"),
//     scaledSize: {
//       width: 34,
//       height: 42,
//     },
//   },
// },

function zoomUI(map) {
  // Container

  const zoomUIContainer = document.createElement("div");
  zoomUIContainer.classList = "zoom-container";

  // Zoom in

  const zoomIn = document.createElement("button");
  zoomIn.classList = "zoom-button";
  zoomIn.title = i18n.t("dispatching.ridePage.zoomIn");

  const zoomInText = document.createElement("div");
  zoomInText.innerHTML = `+`;
  zoomIn.appendChild(zoomInText);

  zoomUIContainer.append(zoomIn);

  zoomIn.addEventListener("click", () => {
    map.setZoom(map.getZoom() + 1);
  });

  // Zoom out

  const zoomOut = document.createElement("button");
  zoomOut.classList = "zoom-button";
  zoomOut.title = i18n.t("dispatching.ridePage.zoomOut");

  const zoomOutText = document.createElement("div");
  zoomOutText.innerHTML = `-`;
  zoomOut.appendChild(zoomOutText);

  zoomUIContainer.append(zoomOut);

  zoomOut.addEventListener("click", () => {
    map.setZoom(map.getZoom() - 1);
  });

  map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(zoomUIContainer);
}

export default {
  components: {
    OrderCard,
    GmapCluster,
    GmapPolyline,
    LogsTable,
    AdditionalInfo,
    LoadingComponent,
  },
  title() {
    if (this.data && this.data.id)
      return `${this.$t("dispatching.ridePage.documentTitle", { id: this.data.id })} | ${this.$t("common.appName")}`;
    return this.$t("dispatching.ridePage.title");
  },
  mixins: [socketEventsMixin],
  events() {
    return {
      captain_location_updated: this.updateDriverLocation,
      [this.api.SOCKET.EVENTS.UPDATE_BOOKING_STATUS]: this.updateStatus,
    };
  },
  computed: {
    startTracking() {
      return [
        !!this.data.now && "ACCEPTED",
        "STARTED",
        "ARRIVED",
        "PICKED_UP",
      ].includes(this.data.status);
    },
    drawRoute() {
      return ["PICKED_UP", "ARRIVED", "DONE", "PAID"].includes(
        this.data.status
      );
    },

    filteredStatusesLogs() {
      return this.getStatusesToShow(this.data.statuses).map((item) => {
        // keep the original status code so the label can be re-translated when the language changes
        if (item._statusCode === undefined) item._statusCode = item.status;
        item["value"] = item._statusCode;
        item.status =
          {
            APPROVED: this.$t("dispatching.ridePage.logStatuses.APPROVED"),
            ACCEPTED: this.$t("dispatching.ridePage.logStatuses.ACCEPTED"),
            PICKED_UP: this.$t("dispatching.ridePage.logStatuses.PICKED_UP"),
            CAPTAIN_CANCELLED: this.$t("dispatching.ridePage.logStatuses.CAPTAIN_CANCELLED"),
            PAX_CANCELLED: this.$t("dispatching.ridePage.logStatuses.PAX_CANCELLED"),
            DONE: this.$t("dispatching.ridePage.logStatuses.DONE"),
            PAID: this.$t("dispatching.ridePage.logStatuses.PAID"),
          }[item._statusCode] || item._statusCode;
        return item;
      });
    },
  },
  data() {
    return {
      data: null,
      complaintSelectedVal: null,
      loading: null,
      complaintStatus: null,
      dialog: false,
      treatConfirmDialog: false,
      pendingComplaintStatus: null,
      previousComplaintStatus: null,
      complaintCategories: [],
      center: { lat: 43.738359, lng: 7.426723 },
      zoom: 16,
      options: options,
      driverLocation: { lat: 0, lng: 0 },
      path: [],
      showByIndex: null,
      actionsColorCoding: {
        APPROVED: "#293462",
        ACCEPTED: "#293462",
        STARTED: "#1CD6CE",
        ARRIVED: "#FEDB39",
        AT_DESTINATION: "#1CD6CE",
        PICKED_UP: "#F57429",
        DONE: "#1C6758",
        PAID: "#1C6758",
        CAPTAIN_CANCELLED: "#9B1FE8",
        SYSTEM_CANCELLED: "#9B1FE8",
        PAX_CANCELLED: "#9B1FE8",
        CANCELLED: "#9B1FE8",
        REJECTED: "#E10015",
      },
      complaint: "",
    };
  },
  methods: {
    changeComplaintStatus(value) {
      if (value === 'Treated') {
        this.previousComplaintStatus = this.complaintStatus;
        this.pendingComplaintStatus = value;
        this.treatConfirmDialog = true;
        return;
      }
      this.doChangeComplaintStatus(value);
    },
    confirmTreatedStatus() {
      this.treatConfirmDialog = false;
      this.doChangeComplaintStatus(this.pendingComplaintStatus);
      this.pendingComplaintStatus = null;
      this.previousComplaintStatus = null;
    },
    cancelTreatedStatus() {
      this.treatConfirmDialog = false;
      this.pendingComplaintStatus = null;
      const prev = this.previousComplaintStatus;
      this.previousComplaintStatus = null;
      this.complaintStatus = null;
      this.$nextTick(() => {
        this.complaintStatus = prev;
      });
    },
    doChangeComplaintStatus(status) {
      this.loading = true;
      axios.put(`complaint/${this.$route.params.id}/update_status`, { status })
        .then((res) => {
          this.loading = false;
          this.complaintStatus = status;
          window.getApp.$emit("SHOW_TOAST", this.$t("dispatching.ridePage.saved"));
          //this.data.all_complaints = res.data.data.all_complaints;
        }).catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
          this.loading = false;
        });
    },

    onlyUnique(value, index, self) {
      self = self.map((item) => item.status);
      return (
        self.indexOf(value.status) === index &&
        !["APPROVED", "DONE", "STARTED", "ARRIVED"].includes(value.status)
      );
    },
    getStatusesToShow(allStatuses) {
      const statuses = {};

      allStatuses.forEach(item => {
        const { status, created_at } = item;
        if ((!["APPROVED", "DONE", "STARTED", "ARRIVED"].includes(status)) && (!(status in statuses) || created_at > statuses[status].created_at)) {
          statuses[status] = item;
        }
      });

      return Object.values(statuses);

    },
    getOrderDetails() {
      axios
        .get(api.ACTIONS.BOOKINGS + "/" + this.$route.params.id)
        .then((res) => {
          this.data = res.data.data;
          this.complaintStatus = this.data.meta.complaint_status;
          this.complaintSelectedVal = this.data.all_complaints.length > 0 ? this.data.all_complaints[0].category_id : null;
          document.title = `${this.$t("dispatching.ridePage.documentTitle", { id: this.data.id })} | ${this.$t("common.appName")}`;
          try {
            this.driverLocation.lat =
              this.data.captain_last_location[0].location.coordinates[1];
            this.driverLocation.lng =
              this.data.captain_last_location[0].location.coordinates[0];
          } catch (err) {
            // do nothing
          }
          if (
            [
              "PICKED_UP",
              "DONE",
              "PAID",
              "REJECTED",
              "CANCELLED",
              "CAPTAIN_CANCELLED",
              "PAX_CANCELLED",
            ].includes(res.data.data.status) &&
            this.data.ride_id
          ) {
            axios
              .get("ride/" + this.data.ride_id + "/route")
              .then((res) => {
                res.data.data.route.forEach((e) => {
                  let obj = {};
                  obj["lat"] = parseFloat(e.lat);
                  obj["lng"] = parseFloat(e.lng);
                  this.path.push(obj);
                });
                this.data.statuses.forEach(({ value, location }) => {
                  if (value === "PICKED_UP")
                    this.path.unshift({
                      lat: parseFloat(location.coordinates[1]),
                      lng: parseFloat(location.coordinates[0]),
                    });
                });
                if (this.drawRoute && this.startTracking) {
                  let lastPathPoint = this.path[this.path.length - 1];
                  this.updateDriverLocation({
                    location: {
                      coordinates: [
                        lastPathPoint.lng,
                        this.path[this.path.length - 1].lat,
                      ],
                    },
                    captain_id: this.data.ride.captain_id,
                  });
                }
                // console.log("Data route");
                // console.log(this.path);
              })
              .catch((err) => {
                console.log(err);
              });
          }
          window.requestAnimationFrame(() => {
            this.$refs.map.$mapPromise.then((map) => {
              zoomUI(map);
              const bounds = new google.maps.LatLngBounds();

              if (this.data.status === "PAID" || this.data.status === "DONE") {
                bounds.extend({
                  lat: this.data.pick_up_location.coordinates[1],
                  lng: this.data.pick_up_location.coordinates[0],
                }); // extend bounds to pickup marker
                bounds.extend({
                  lat: this.data.pull_down_location.coordinates[1],
                  lng: this.data.pull_down_location.coordinates[0],
                });
              } else if (
                ![
                  "CANCELLED",
                  "CAPTAIN_CANCELLED",
                  "PAX_CANCELLED",
                  "SYSTEM_CANCELLED",
                ].includes(this.data.status)
              ) {
                bounds.extend({
                  lat: this.data.pick_up_location.coordinates[1],
                  lng: this.data.pick_up_location.coordinates[0],
                }); // extend bounds to pickup marker
              } else {
                let location =
                  this.data.statuses[this.data.statuses.length - 1].location;
                bounds.extend({
                  lat: location.coordinates[1],
                  lng: location.coordinates[0],
                });
              }
              map.fitBounds(bounds);
              let zoomLvl = map.getZoom();
              if (![
                "PAID",
                "DONE"
              ].includes(this.data.status)) {
                google.maps.event.addListenerOnce(map, 'idle', () => {
                  map.setZoom(this.zoom);
                });
              }

            });
          });
        })
        .catch((error) => {
          console.log("RidePage Error: ", error);
        });
    },
    updateDriverLocation(data) {
      if (
        this.data.ride &&
        data.captain_id == this.data.ride.captain_id &&
        this.startTracking
      ) {
        this.driverLocation.lat = data.location.coordinates[1];
        this.driverLocation.lng = data.location.coordinates[0];
        if (this.drawRoute)
          this.path.push({
            lat: data.location.coordinates[1],
            lng: data.location.coordinates[0],
          });
        window.requestAnimationFrame(() => {
          this.$refs.map.$mapPromise.then((map) => {
            let zoomLvl = map.getZoom();
            const bounds = new google.maps.LatLngBounds();
            bounds.extend({
              lat: this.driverLocation.lat,
              lng: this.driverLocation.lng,
            });
            map.fitBounds(bounds);
            map.setZoom(zoomLvl);
          });
        });
      }
    },
    formSvg(color) {
      return (
        "data:image/svg+xml;utf8," +
        encodeURIComponent(`
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="33.625" height="41.385" viewBox="0 0 33.625 41.385">
        <defs>
          <clipPath id="clip-path">
            <rect id="Rectangle_3619" data-name="Rectangle 3619" width="33.625" height="41.385" transform="translate(163 565)" fill="none"/>
          </clipPath>
        </defs>
        <g id="Mask_Group_6" data-name="Mask Group 6" transform="translate(-163 -565)" clip-path="url(#clip-path)">
          <g id="Monaco_Pin_Active" data-name="Monaco Pin Active" transform="translate(163.259 565)">
            <g id="Group_322" data-name="Group 322" transform="translate(6.622 22.284)">
              <path id="Path_374" data-name="Path 374" d="M42.018,34.462l-9.932,19.1-9.932-19.1a17.086,17.086,0,0,0,19.865,0Z" transform="translate(-22.154 -34.462)" fill="${color}"/>
            </g>
            <g id="Group_323" data-name="Group 323" transform="translate(0)">
              <circle id="Ellipse_3825" data-name="Ellipse 3825" cx="16" cy="16" r="16" transform="translate(0.741)" fill="${color}"/>
              <path id="Path_376" data-name="Path 376" d="M23.081,19.3a9.705,9.705,0,0,1-5.418-1.658l-.123-.118a8.642,8.642,0,0,1-3.694-7.1,9.242,9.242,0,0,1,18.47,0,8.642,8.642,0,0,1-3.694,7.1l-.123.118A9.705,9.705,0,0,1,23.081,19.3Z" transform="translate(-6.527 5.499)" fill="#fff"/>
            </g>
          </g>
        </g>
      </svg>`)
      );
    },
    getLogs() {
      axios
        .get(`${api.ACTIONS.LOGS}/${this.$route.params.id}`)
        .then((res) => {
          this.logs = res.data.data.data;
        })
        .catch((err) => { });
    },
    addComplaint() {
      this.$dialova({
        title: this.$t("dispatching.ridePage.complaintDescription"),
        input: this.$t("dispatching.ridePage.enterComplaint"),
        loader: true,
        fileUpload: this.$t("dispatching.ridePage.soundFiles")
        // dropdown: {
        //   options: this.complaintCategories,
        //   placeholder: 'Select a category',
        //   name: 'complaint_type'
        // }
      }).then(({ value, close, files, dropdown }) => {
        const params = new FormData();
        if (value)
          params.append("description", value);
        params.append("booking_id", this.$route.params.id);
        //params.append("category_id", dropdown);
        if (files) {
          console.log(files.length);
          for (let i = 0; i < files.length; i++)
            params.append("wav_files[]", files[i]);
        }
        axios
          .post(`complaint/booking/${this.$route.params.id}/create`, params)
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("dispatching.ridePage.saved"));
            this.getOrderDetails();
            close();
          })
          .catch((err) => {
            console.log("err");
            console.log(err.response.data.message);
            window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
            close();
          });
        // .finally(() => close());
      });
    },
    saveCategory() {
      if (!this.complaintSelectedVal) {
        window.getApp.$emit("SHOW_TOAST", this.$t("dispatching.ridePage.chooseCategory"), "red");
        return;
      }
      this.loading = true;
      this.axios
        .post(`complaint/category`, {
          category_id: this.complaintSelectedVal,
          booking_id: this.$route.params.id
        })
        .then((res) => {
          this.loading = false;
        })
        .catch((err) => {
          // console.log(err.message);
          this.loading = false;
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
        });
    },
    showDetails(complaint, id) {
      const audioPromise = axios.get(`complaint/${id}/audio`);
      const commentPromise = axios.get(`complaint_comments/${id}/get_comments`);
      Promise.allSettled([audioPromise, commentPromise]).then(([audios, comments]) => {
        complaint.audios = audios.value.data.data;
        complaint.comments = comments.value.data.data;
        complaint.comments.forEach(comment => {
          comment.audios = comment.audios.map((item) => {
            return {
              item: item,
              loading: false,
              urlObject: ''
            }
          });
        });
        this.$complaintDialog({
          complaint: complaint,
          hideCancel: true,
          fileUpload: this.$t("dispatching.ridePage.soundFiles"),
          list: audios.value.data.data,
          additionalData: {
            id: id
          }
        })
      });

      // axios.get(`complaint/${id}/audio`).then((res) => {
      //   this.$complaintDialog({
      //     complaint:complaint,
      //     hideCancel: true,
      //     list:audios,
      //     additionalData: {
      //       id: id
      //     }
      //   })
      //     .then(() => {})
      //     .catch(() => {});
      // });
    },
    updateStatus(id, newStatus, oldStatus, driver, rideId, cancellationReason = null, bySystem = null) {
      if (id === this.data.id) {
        this.data.status = newStatus;
        if (driver) {
          this.data["captain_first_name"] = driver.first_name;
          this.data["captain_last_name"] = driver.last_name;
          this.data["taxi_number"] = driver.username;
          this.data['car_brand_model'] = driver.car_brand_model;
          this.data['car_brand'] = driver.car_brand;
          this.data['car_color'] = driver.car_color;
          this.data['car_plate_number'] = driver.car_plate_number;
          this.data["ride"] = {};
          this.data.ride["captain_id"] = driver.id;
          this.data.captain_conversation_id = driver.conversation_id;
          this.data.method = driver.method;
        }
        if (cancellationReason) {
          if (newStatus == "CAPTAIN_CANCELLED")
            this.data['captain_cancellation_reason'] = cancellationReason;
          else if (newStatus == 'SYSTEM_CANCELLED' || newStatus == 'REJECTED') {
            if (bySystem)
              this.data['system_cancellation_reason'] = cancellationReason;
            else
              this.data['user_cancellation_reason'] = cancellationReason;
          }

        }
        if (rideId) {
          this.data["ride_id"] = rideId;
        }
        axios.get(`booking/${id}/statuses`).then((res) => {
          this.data.statuses = res.data.data;
        });
      }
    },
  },
  created() {
    this.getOrderDetails();
    this.getLogs();
    // console.log(this.$store.getters.getBookingsUpdates);
    // this.$store.dispatch("listenBookingUpdate", this.$route.params.id || 'x');
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("fetchComplaintCategories")
      .then((data) => {
        this.complaintCategories = data;
        this.categoryDialog = true;
        this.loading = false;
      })
      .catch((err) => {
        console.error(err);
        this.loading = false;
      });
  }
};
</script>

<style lang="scss">
.treat-confirm-modal {
  padding: 36px 28px;
  background: white;
  border-radius: 8px;
  position: relative;
  box-sizing: border-box;
  font-family: Poppins;
}

.tc-close-button {
  right: 0;
  position: absolute;
  bottom: calc(100% + 12px);
  background: rgba(#fff, 0.6);
  border: 1px solid #fff;
  width: 26px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  cursor: pointer;
  color: #84969e;
  user-select: none;

  span {
    margin-bottom: 1px;
    font-size: 12px;
  }
}

.tc-title {
  color: #202731;
  font-size: 16pt;
  padding: 0;
  margin: 0;
  font-weight: 500;
  word-break: break-word;
  font-family: Poppins;
}

.tc-text {
  margin-top: 8px;
  color: #84969e;
  font-size: 12pt;
  font-family: Poppins;
}

.tc-buttons {
  width: 100%;
  margin-top: 22px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;

  .tc-btn {
    padding: 10px 28px;
    background: #e10015;
    color: white;
    border: none;
    border-radius: 4px;
    font-weight: 400;
    font-family: Poppins;
    cursor: pointer;
    transition: 0.1s;

    &[outline] {
      background: #fff;
      border: 1px solid #e10015;
      color: #e10015;
    }

    &:hover {
      box-shadow: 0px 0px 6px rgba(#202731, 0.12);
    }
  }
}

.complaint-button {
  padding: 5px;
  width: 100%;
  background: #d71010;
  color: white;
}

.complaints-container {
  width: 100%;
  height: auto;
  float: left;
  padding: 1rem 1.25rem;
  background: white;
  max-height: 400px;
  border-radius: 8px;
  box-shadow: 0px 0px 6px rgba($color: #000000, $alpha: 0.08);
  overflow-y: overlay;

}

.card-container {
  width: 430px;
  height: auto;
  position: absolute;
  z-index: 4;
  bottom: 0px;
  left: 55px;
  max-height: calc(100vh - 64px);
  padding-top: 22px;
  padding-bottom: 22px;
  overflow-y: overlay;

  &::-webkit-scrollbar {
    width: 0;
  }

  .scroller {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    flex-direction: column;
    gap: 12px;

    div {
      flex-grow: 0;
      flex-shrink: 1;
    }
  }
}

.map {
  height: calc(100vh - 64px);
  outline: none;
}

.zoom-container {
  width: max-content;
  height: max-content;
  bottom: 20px !important;
  right: 55px !important;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.zoom-button {
  height: 48px;
  width: 48px;
  background-color: #fff;
  border: 1px solid #c1c5d8;
  color: #222629;
  font-size: 18px;
  border-radius: 10px;
  outline: none;
}

.additional-info-logs {
  color: #222629;

  tr,
  td,
  th {
    padding: 2px;
  }

  tr {
    td:first-child {
      padding-left: 0;
    }
  }
}
</style>
